import React from 'react'

const OrderComplete = () => (
  <div className="order-complete">
    <h2>表單完成</h2>
  </div>
);

export default OrderComplete;